import type { CSSProperties } from "react";
import { hexToRgba } from "../../utils/colorUtils";

const DEFAULT_MODAL_TITLE = "Gift Card";
const DEFAULT_MODAL_SUBTEXT = "Redeem your gift card and save more!";
const DEFAULT_ACCENT_COLOR = "#000000";

/** How long a wallet top-up's confirmation strip stays fully up before it starts leaving. */
const RECHARGE_NOTICE_DURATION_MS = 4000;

const RECHARGE_NOTICE_TRANSITION_MS = 300;
const defaultFormatAmount = (value: number) => `₹${value}`;
const GIFT_CARD_INPUT_FOCUS_CLASS =
  "focus:!ui-shadow-[shadow:var(--gc-input-focus-shadow)]";

const getGiftCardInputFocusStyle = (accentColor: string) => {
  const shadow = `0 0 0 1.5px rgba(0, 0, 0, 0.30) inset, 0 0 0 1.5px ${hexToRgba(
    accentColor,
    0.3,
  )} inset, 0 0.5px 0 0 ${hexToRgba(
    accentColor,
    0.1,
  )}, 0 1px 3px 0 rgba(26, 26, 26, 0.08)`;

  return { "--gc-input-focus-shadow": shadow } as CSSProperties;
};

/** Fixed error styling per design spec — not merchant-configurable, unlike the focus ring. */
const GIFT_CARD_INPUT_ERROR_CLASS =
  "data-[error=true]:!ui-bg-white data-[error=true]:!ui-bg-[image:var(--gc-input-error-bg)] data-[error=true]:!ui-shadow-[shadow:var(--gc-input-error-shadow)]";

const GIFT_CARD_INPUT_ERROR_STYLE: CSSProperties = {
  "--gc-input-error-bg":
    "linear-gradient(0deg, rgba(251, 44, 54, 0.04) 0%, rgba(251, 44, 54, 0.04) 100%)",
  "--gc-input-error-shadow":
    "0 0 0 1.5px rgba(0, 0, 0, 0.30) inset, 0 0 0 1.5px #E7000B inset, 0 0.5px 0 0 rgba(67, 42, 46, 0.10), 0 1px 3px 0 rgba(26, 26, 26, 0.08)",
} as CSSProperties;

export {
  DEFAULT_MODAL_TITLE,
  DEFAULT_MODAL_SUBTEXT,
  DEFAULT_ACCENT_COLOR,
  RECHARGE_NOTICE_DURATION_MS,
  RECHARGE_NOTICE_TRANSITION_MS,
  defaultFormatAmount,
  GIFT_CARD_INPUT_FOCUS_CLASS,
  getGiftCardInputFocusStyle,
  GIFT_CARD_INPUT_ERROR_CLASS,
  GIFT_CARD_INPUT_ERROR_STYLE,
}
